module.exports = __webpack_public_path__ + "img/misosuppeohnehintergrund.33363ce8.png";